export const TID = {
  // landing
  landingTherapist: "landing-therapist-cta",
  landingStudent: "landing-student-cta",
  landingTitle: "landing-title",

  // therapist auth
  loginEmail: "login-email-input",
  loginPassword: "login-password-input",
  loginSubmit: "login-submit-btn",
  loginError: "login-error",
  registerName: "register-name-input",
  registerEmail: "register-email-input",
  registerPassword: "register-password-input",
  registerSubmit: "register-submit-btn",
  registerError: "register-error",

  // student auth
  studentLoginUsername: "student-login-username",
  studentLoginPin: "student-login-pin",
  studentLoginSubmit: "student-login-submit",
  studentLoginError: "student-login-error",

  // layout
  navLowStim: "nav-low-stim-toggle",
  navHome: "nav-home-link",
  logout: "logout-btn",

  // therapist dashboard
  therapistDashboard: "therapist-dashboard",
  addStudentBtn: "add-student-btn",
  studentRow: (id) => `student-row-${id}`,
  studentOpen: (id) => `student-open-${id}`,
  newStudentName: "new-student-name",
  newStudentUsername: "new-student-username",
  newStudentPin: "new-student-pin",
  newStudentSubmit: "new-student-submit",
  newStudentCancel: "new-student-cancel",

  // student detail / curation
  studentDetail: "student-detail",
  tabProfile: "tab-profile",
  tabBubbles: "tab-bubbles",
  tabReport: "tab-report",
  profileSelect: (sys) => `profile-select-${sys}`,
  profileSave: "profile-save-btn",
  bubbleToggle: (id) => `bubble-toggle-${id}`,
  bubblesSave: "bubbles-save-btn",
  reportChart: "report-chart",
  reportTotal: "report-total",

  // student app
  studentHome: "student-home",
  homeChooseFeelings: "home-choose-feelings",
  homeChooseBoxes: "home-choose-boxes",
  studentBoxes: "student-boxes",
  studentBoxTile: (sys) => `student-box-${sys}`,
  studentBox: "student-box-screen",
  studentBubble: (id) => `student-bubble-${id}`,
  studentGuidance: "student-guidance",
  studentGuidanceDone: "student-guidance-done",
  studentBackToBoxes: "student-back-to-boxes",
  studentBackHome: "student-back-home",

  // feelings
  feelingsGrid: "feelings-grid",
  feelingTile: (k) => `feeling-tile-${k}`,
  feelingScreen: "feeling-screen",

  // self-serve / explore
  exploreHome: "explore-home",
  exploreTryNow: "landing-explore-cta",
};
